import { type Order } from '@/api/registration';
import { type ApiResponse } from '@/api/tenantClient';
import BaseMessageBarError from '@/base/MessageBar/Error';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { UiHStack, UiLink, UiStack, uiStyles, UiTable, UiTbody, UiTd, UiText, UiTh, UiThead, UiTr } from '@/lib/ui';
import { TableContainer } from '@chakra-ui/react';
import { type UseQueryResult } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { type FC } from 'react';

interface OrderProps {
  orderListQuery: UseQueryResult<ApiResponse<Order>, Error>
  emailOwner: string | undefined
}

const OrderList: FC<OrderProps> = ({ orderListQuery, emailOwner }) => {
  return (
    <QueryContainer query={orderListQuery} errorMessage="Failed to load order data.">
      {(ordersData) => {
        const errors = ordersData?.errors ?? [];
        const orders = ordersData?.items ?? [];

        if (errors.length > 0) {
          return (
            <UiStack flexGrow={1} paddingBottom={4}>
              {errors.map((error) => {
                return (
                  <BaseMessageBarError key={error} mt={3}>{error}</BaseMessageBarError>
                );
              })}
            </UiStack>
          );
        }
        return (
          <UiStack spacing={4}>
            <UiHStack justifyContent={'space-between'}>
              <UiText variant={'title'}>
                Orders
              </UiText>
            </UiHStack>
            <UiStack
              p={8}
              bgColor={'#fff'}
              borderRadius={uiStyles.borderRadius}
              shadow={uiStyles.cardShadow}
            >
              <TableContainer>
                <UiTable
                  shadow={'none'}
                  // borderColor={'gray.300'}
                  // borderWidth={'1px'}
                  // borderStyle={'solid'}
                  // borderRadius={uiStyles.borderRadius}
                >
                  <UiThead>
                    <UiTr>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Serial
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Date Paid
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Invoice
                        </UiText>
                      </UiTh>
                    </UiTr>
                  </UiThead>
                  <UiTbody>
                    {orders.filter((order) => {
                      return order.attendee.email === emailOwner;
                    }).map((order, index) => {
                      return (
                        <UiTr key={index}>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {order.serial}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {order.purchasedAt ? dayjs(order.purchasedAt).format('DD/MM/YYYY HH:mm') : ''}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <UiLink href={order.invoiceUrl} isExternal color={'blue'}>
                              Download
                            </UiLink>
                          </UiTd>
                        </UiTr>
                      );
                    })}
                  </UiTbody>
                </UiTable>
              </TableContainer>
            </UiStack>
          </UiStack>
        );
      }}
    </QueryContainer>
  );
};

export default OrderList;
